import React from "react";

export const SmokeParticles = ({ count = 4, intensity = "soft" }) => {
  const particles = Array.from({ length: count });
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
      {particles.map((_, i) => {
        const delay = (i * 4.2) % 18;
        const duration = 14 + (i % 3) * 4;
        const left = (i * 23 + 10) % 90;
        const scale = intensity === "strong" ? 1.6 : 1;
        return (
          <span
            key={i}
            className="smoke-particle"
            style={{
              left: `${left}%`,
              animationDelay: `-${delay}s`,
              animationDuration: `${duration}s`,
              transform: `scale(${scale})`,
            }}
          />
        );
      })}
    </div>
  );
};

export const Embers = ({ count = 18 }) => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
      {Array.from({ length: count }).map((_, i) => {
        const delay = (i * 1.3) % 12;
        const duration = 8 + (i % 5) * 2;
        const left = (i * 13 + 5) % 95;
        const ex = ((i * 17) % 80) - 40;
        return (
          <span
            key={i}
            className="ember"
            style={{
              left: `${left}%`,
              animationDelay: `-${delay}s`,
              animationDuration: `${duration}s`,
              "--ex": `${ex}px`,
            }}
          />
        );
      })}
    </div>
  );
};
